import { useSynqoHttp, type Result } from '@synqo/frontend-component-library';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';

export function useApiObject<TData>(resourceBasePath: string, resourceName: string, initialId?: string) {
    const resourcePath = `${resourceBasePath}/`;

    const http = useSynqoHttp(resourcePath);
    const [id, setId] = useState<string>(initialId ?? '');

    const query = useQuery({
        queryFn: () => (id === '' ? null : http.get<Result<TData>>(id)),
        queryKey: [id, resourceName],
    });

    const result = query.data;
    const data = result?.data;

    return {
        data,
        setId,
    };
}
